module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [(_vm.noForm) ? _c('i', [_vm._v(_vm._s(_vm.label) + " ")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "value-key": "id",
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "filterable": "",
      "remote": "",
      "remote-method": _vm.findLandlordList,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "formData"
    }
  }, _vm._l((this.landlords), function(org) {
    return _c('el-option', {
      key: org.id,
      attrs: {
        "label": org.name,
        "value": org
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(org.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n        " + _vm._s(org.shortName) + "\n      ")])])
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-534e6cca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectLandlord.vue
// module id = 1568
// module chunks = 0